'use client'

import dynamic from 'next/dynamic'

import { HeaderLogo } from '@/components/layout/logo'

const HeaderActions = dynamic(
  () =>
    import('@/components/layout/navigation/header-layout-client').then(mod => ({
      default: mod.HeaderActions
    })),
  {
    ssr: false,
    loading: () => (
      <div
        aria-hidden
        className="flex h-7 w-[168px] shrink-0 items-center md:h-9 md:w-[220px]"
      />
    )
  }
)

export function CompanyHeader() {
  return (
    <header className="site-header">
      <HeaderLogo />
      <div className="site-header__actions">
        <HeaderActions />
      </div>
    </header>
  )
}
